export const firebaseConfig = {
    apiKey: 'AIzaSyDLc4le3IJ6mdAkQbRpyaiY_LyR0nN2T8s',
    authDomain: 'appgratuita-new.firebaseapp.com',
    databaseURL: 'https://appgratuita-new.firebaseio.com',
    projectId: 'appgratuita-new',
    storageBucket: 'appgratuita-new.appspot.com',
    messagingSenderId: '788211761260'
  };

/*
  apiKey: "AIzaSyDLc4le3IJ6mdAkQbRpyaiY_LyR0nN2T8s",
  authDomain: "appgratuita-new.firebaseapp.com",
  databaseURL: "https://appgratuita-new.firebaseio.com",
  projectId: "appgratuita-new",
  storageBucket: "appgratuita-new.appspot.com",
  messagingSenderId: "788211761260",
  appId: "1:788211761260:web:55cba9d9eba7c175"

  */